<ion-content *ngIf="toBeAddedItems?.length || addedItems?.length; else empty">
	<ion-list *ngIf="toBeAddedItems?.length">
		<ion-list-header color="success" lines="full" mode="md">
			<ion-label mode="md">
				To Be Added
			</ion-label>
		</ion-list-header>
		<ion-item-group *ngFor="let item of toBeAddedItems">
			<ion-item detail="false">
				<ion-grid>
					<ion-row>
						<ion-col size="12" size-sm>
							<ion-text>
								<span>{{ item.categoryDesc }}</span>
								<span *ngIf="item.equipName">:</span>
								<span *ngIf="item.equipName" class="equip-name">
									{{ item.equipName }}
								</span>
							</ion-text>
						</ion-col>
					</ion-row>
					<ion-row class="button-row">
						<ion-col size="6" size-sm>
							<ion-button
								expand="block"
								(click)="onClickAddInventory(item)"
							>
								Add
							</ion-button>
						</ion-col>
						<ion-col size="6" size-sm>
							<ion-button
								expand="block"
								(click)="onClickRemoveToBeAddedInventory(item)"
								color="danger"
							>
								Remove
							</ion-button>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-item>
		</ion-item-group>
	</ion-list>
	<ion-list *ngIf="addedItems?.length">
		<ion-list-header color="primary" lines="full" mode="md">
			<ion-label mode="md">
				Added
			</ion-label>
		</ion-list-header>
		<ion-item-group
			*ngFor="let item of addedItems; index as index"
			mode="md"
		>
			<app-inventory-item
				[item]="item"
				[index]="index"
				[isExpanded]="isVisible(index)"
				(toggledSection)="onClickToggleSection($event)"
			></app-inventory-item>
		</ion-item-group>
	</ion-list>
</ion-content>

<ng-template #empty>
	<app-empty-list-item
		message="No added inventory on this appointment"
	></app-empty-list-item>
</ng-template>
